import { Box, Button, Stack, Typography, alpha } from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { useTranslation } from "../../../i18n";
import { athenaColors } from "../../../theme/palette";
import {
  athenaDarkSectionSx,
  athenaDarkPrimaryButtonSx,
} from "../../layout/AthenaDialogStyles";

export type WizardStepCompleteProps = {
  onClose: () => void;
};

export default function WizardStepComplete({ onClose }: WizardStepCompleteProps) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2.5} alignItems="center" sx={{ py: 2 }}>
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: alpha(athenaColors.periwinkle, 0.2),
          border: `2px solid ${alpha(athenaColors.periwinkle, 0.5)}`,
        }}
      >
        <VerifiedUserIcon sx={{ fontSize: 48, color: athenaColors.periwinkle }} />
      </Box>
      <Typography variant="h5" sx={{ fontWeight: 700, color: athenaColors.white }}>
        {t("contracts_wizard.complete.title", "You're all set!")}
      </Typography>
      <Box sx={athenaDarkSectionSx}>
        <Typography variant="body2" sx={{ color: alpha(athenaColors.white, 0.9), lineHeight: 1.6, textAlign: "center" }}>
          {t(
            "contracts_wizard.complete.body",
            "Your legal setup is complete. You can access these documents anytime from this menu."
          )}
        </Typography>
        <Typography variant="caption" sx={{ color: alpha(athenaColors.white, 0.7), display: "block", mt: 1, textAlign: "center" }}>
          {t("contracts_wizard.complete.hint", "If you need to make changes, return here to update your agreements or consent templates.")}
        </Typography>
      </Box>
      <Button onClick={onClose} sx={athenaDarkPrimaryButtonSx}>
        {t("contracts_wizard.complete.close", "Close")}
      </Button>
    </Stack>
  );
}
